import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const faviconResolver: FieldResolver = (metadata: Metadata) =>
  ({ favicon: metadata.getFavicon() } as StreamData)

export default faviconResolver
